import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { getUserInfo as usersliceApi, type UserType } from '@/services/userInfoApi';
import type { RootState } from '../store';
import { type StripeErrorType } from '@/services/paymenApi';

// Define a type for the slice state
export interface PageErrorInfoType {
  errorCode: string;
  errorInfo?: string;
  stripeCode?: StripeErrorType;
}

interface CounterState {
  userInfo: UserType;
  pageErrorInfo: PageErrorInfoType | null;
  URLQueryParams: { [key: string]: string };
}

// Define the initial state using that type
const initialState: CounterState = {
  userInfo: { email: null, isInstitutionUser: false, mobileNumber: '', id: 0 },
  pageErrorInfo: null,
  URLQueryParams: {},
};

export const getUserInfo = createAsyncThunk('user/getUserInfo', async (userData: {}, { rejectWithValue }) => {
  try {
    const response = await usersliceApi();
    const { errorCode, email, isInstitutionUser, mobileNumber, id } = response;
    if (errorCode === '0') {
      const data = { email, isInstitutionUser, mobileNumber, id };
      return data;
    }
    throw new Error('');
  } catch (err: any) {
    return rejectWithValue('error');
  }
});

export const userslice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setPageErrorInfo: (state, action: PayloadAction<PageErrorInfoType>) => {
      state.pageErrorInfo = action.payload;
    },
    setURLQueryParams: (state, action: PayloadAction<{ [key: string]: string }>) => {
      state.URLQueryParams = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUserInfo.fulfilled, (state, action) => {
      state.userInfo = action.payload;
    });
    builder.addCase(getUserInfo.rejected, (state, action) => {
      state.userInfo = {
        email: null,
        id: 0,
        isInstitutionUser: false,
        mobileNumber: '',
      };
    });
  },
});

export const { setPageErrorInfo, setURLQueryParams } = userslice.actions;

export default userslice.reducer;
